import React, { useEffect, useMemo, useState} from 'react'
import styles from "./Table.module.css";

const Table = ({ ratingCalc, group, groups, schemaType, schemas, year, getDigitalPortrait, scrollRef, loading, setIsRadial, setIsCompare, isCompare, getCalculation, month, mid, setMid, setPortraits}) => {
  const [localGroup, setlLocalGroup] = useState(null);
  const [localGroups, setlLocalGroups] = useState(null);
  const [stickys, setSticky] = useState(false);
  
window.onscroll = function() {myFunction()};

const myFunction = () => {

  if (window.pageYOffset >= 370) {
    setSticky(true);
  } else {
    setSticky(false);
  }
}

  useEffect(() => {
    group && group.length > 0 && setlLocalGroup(group);
  }, [group])

  useEffect(() => {
    groups && groups.length > 0 && setlLocalGroups(groups);
  }, [groups])

  const handleGetPortrain = (mids, rad) => {
    setIsRadial(rad);
    setIsCompare(false);

    // Если schemaType=true, извлекаем данные из ratingCalc вместо запроса к API
    if (schemaType && ratingCalc && ratingCalc.length && ratingCalc[0]?.user_results) {
      // Извлекаем данные пользователя из новой структуры ratingCalc
      const userData = ratingCalc.map(category => {
        const user = category.user_results?.find(u => u.mid === mids);
        return {
          id: category.first_level_id,
          title: category.first_level_title,
          alias: category.first_level_title,
          lastname: user?.lastname || '',
          firstname: user?.firstname || '',
          patronymic: user?.patronymic || '',
          points: user?.last_level_points || 0,
          mid: mids
        };
      });
      setPortraits(userData);
      if (scrollRef !== null && !loading) {
        scrollRef.current.scrollIntoView({ behavior: "smooth" });
      }
      return;
    }

    // Старая логика для !schemaType
    if (schemas && year && mids) {
      getDigitalPortrait(schemas, year, mids);
      if (scrollRef !== null && !loading) {scrollRef.current.scrollIntoView({ behavior: "smooth" });}
    } else if (localStorage.getItem('schema') && localStorage.getItem('year'), mids) {
      getDigitalPortrait(localStorage.getItem('schema'), localStorage.getItem('year'), mids);
      if (scrollRef !== null && !loading) {scrollRef.current.scrollIntoView({ behavior: "smooth" });}
    }
  }

  // Заголовки колонок (first_level_title)
  const headers = useMemo(() => {
    if (ratingCalc && ratingCalc.length && schemaType) {
      return ratingCalc.map(item => item.first_level_title);
    }
    return [];
  }, [ratingCalc, schemaType]);

  // Группировка по пользователям для schemaType
  const users = useMemo(() => {
    if (ratingCalc && ratingCalc.length && schemaType) {
      // Новая структура: ratingCalc = [{ first_level_title, first_level_id, user_results: [...] }, ...]
      const userMap = {};

      ratingCalc.forEach((category, categoryIndex) => {
        if (category.user_results) {
          category.user_results.forEach(user => {
            if (!userMap[user.mid]) {
              userMap[user.mid] = {
                mid: user.mid,
                firstname: user.firstname,
                lastname: user.lastname,
                patronymic: user.patronymic,
                points: new Array(ratingCalc.length).fill(null),
                totalPoints: 0
              };
            }
            const pts = user.last_level_points ? parseFloat(user.last_level_points) : 0;
            userMap[user.mid].points[categoryIndex] = pts;
            userMap[user.mid].totalPoints += pts;
          });
        }
      });

      return Object.values(userMap);
    }

    // Старая логика для !schemaType
    if (ratingCalc && ratingCalc.length) {
      const tmp = {};
      for (const line of ratingCalc) {
        if (tmp[line.mid]) {
          tmp[line.mid].push(line);
        } else {
          tmp[line.mid] = [line];
        }
      }
      return [...Object.values(tmp)];
    }
  }, [ratingCalc, schemaType])

  return (
    <>

      {ratingCalc && ratingCalc.length && !schemaType &&
        <div className={`${0 ? styles.wrapperStickyActive : styles.wrapperSticky}`}>  
          <table>
            <tbody>
              <tr className={styles.digitalRatingTabHead}>
                <td style={{width: '64px'}}>№ п/п</td>
                <td style={{width: '383px'}}>Фамилия И.О. (учебная группа)</td>
                <td style={{width: '173px'}}>Значение рейтинга</td>
                <td style={{width: '160px'}}>Место в рейтинге</td>
                <td style={{width: '145px'}}>Цифровой портрет</td>
                {/* <td colSpan="3">Круговая диграмма</td> */}
              </tr>
            </tbody>
          </table>
        </div>
      }

      {
        users && users.length && schemaType &&
        <div className={`${0 ? styles.wrapperStickyActive : styles.wrapperSticky}`}>
          <table>
            <tbody>
              <tr className={styles.digitalRatingTabHead}>
                <td>№ п/п</td>
                <td style={{width: '180px'}}>Фамилия И.О. (учебная группа)</td>
                {headers.map((title, idx) =>
                  <td key={idx}>{title}</td>
                )}
                <td style={{width: '40px'}}>Сумма баллов</td>
                <td style={{width: '60px'}} className={styles.placeDigital}>Место</td>
                <td>Диаграмма</td>
              </tr>
            </tbody>
          </table>
        </div>
      }

    {
      ratingCalc && ratingCalc.length && !schemaType &&
        <div className={styles.wrapperRating}>
          <table>
            <tbody>
              <tr className={styles.digitalRatingTabHead}>
                <td colSpan="1">№ п/п</td>
                <td colSpan="6">Фамилия И.О. (учебная группа)</td>
                <td colSpan="2">Значение рейтинга</td>
                <td colSpan="2">Место в рейтинге</td>
                <td colSpan="1">Цифровой портрет</td>
                {/* <td colSpan="3">Круговая диграмма</td> */}
              </tr>

              {
                ratingCalc
                .sort((a, b) => b.points - a.points)
                .map((el, index) =>
                  <tr key={el.id}>
                  <td colSpan="1">{index+1}</td>
                  <td colSpan="6" className={styles.namesDigital}>&ensp;&ensp;
                    {`${el.lastname ? el.lastname : ''} ${el.firstname ? el.firstname : ''} ${el.patronymic ? el.patronymic : ''} 
                    (${localGroups && localGroups.filter(gr => gr.gid == localGroup)[0]?.name ? localGroups.filter(gr => gr.gid == localGroup)[0]?.name : ''})`}
                  </td>
                  <td colSpan="2">{el.points > 0 ? Math.floor(parseFloat(el.points).toFixed(3)*1000)/1000 : ''}</td>
                  <td colSpan="2">{index+1}</td>
                  <td colSpan="1"><i onClick={() => handleGetPortrain(el.mid, false)}>
                    <svg className={styles.digSvg} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"></path></svg></i></td>
                  
                  {/* <td colSpan="1"><i onClick={() => handleGetPortrain(el.mid, true)}>
                    <svg className={styles.digSvgCircle} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z"></path></svg></i></td> */}
                </tr> 
                )
              }
            </tbody>
          </table>
        </div>
    }

    {users && users.length > 0 && schemaType && (
      <div className={styles.wrapperRating}>
        <table>
          <tbody>
            <tr className={styles.digitalRatingTabHead}>
              <td colSpan="1">№ п/п</td>
              <td colSpan="2">Фамилия И.О. (учебная группа)</td>
              {headers.map((title, idx) => (
                <td colSpan="1" key={`header-${idx}`}>
                  {title}
                </td>
              ))}
              <td colSpan="1">Сумма баллов</td>
              <td colSpan="2" className={styles.placeDigital}>Место</td>
              <td colSpan="1">Диаграмма</td>
            </tr>

            {users
              .sort((a, b) => (b.totalPoints || 0) - (a.totalPoints || 0))
              .map((user, index) => (
                <tr className={styles.digitalRatingTabBody} key={user.mid || index}>
                  <td colSpan="1">{index + 1}</td>

                  <td colSpan="2" className={styles.namesDigital}>
                    &ensp;&ensp;
                    {`${user.lastname || ''} ${user.firstname || ''} ${user.patronymic || ''} (${groups?.find(gr => gr.gid == group)?.name || ''})`}
                  </td>

                  {user.points.map((pts, j) => (
                    <td colSpan="1" key={`points-${user.mid}-${j}`} className={styles.listTd}>
                      {pts > 0 ? Math.round(pts * 1000) / 1000 : ''}
                    </td>
                  ))}

                  <td colSpan="1">
                    {user.totalPoints > 0 ? user.totalPoints.toFixed(3) : ''}
                  </td>

                  <td colSpan="2">{index + 1}</td>

                  <td colSpan="1">
                    <i onClick={() => handleGetPortrain(user.mid, false)}>
                      <svg
                        className={styles.digSvg}
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1.5em"
                        width="1.5em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"></path>
                      </svg>
                    </i>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )}

  </>
  )
}

export default Table
